













































































































































































import { CrudService } from '@/data/services/crud.service';
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { Qualification } from '@/data/models/qualification.model';
import { Search } from '@/data/models/search.model';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class AttoreQualifications extends Vue{
	@Inject('CrudService') qualificationCrudService!: CrudService<Qualification>;
	@Prop() actorid!: number;

	search = new Search('qualification');
	qualifications: Qualification[] = [];
	isModalOpen = false;
	newQualification: Qualification = new Qualification();
	loading = false;
	
	constructor() { 
		super();
	}

	@Watch('actorid')
	onActoridChange() { 
		this.search.addSimpleFilter('actorid', this.actorid);
		this.loadQualifications();
	}
	
	loadQualifications() {
		this.loading = true;
		this.qualificationCrudService.searchEntities(Qualification, 'qualification', this.search, this.search.page)
			.then((results) => {
				this.loading = false;
				this.qualifications = results;
			});
	}

	openAddModal() {
		this.newQualification = new Qualification();
		this.newQualification.actorid = this.actorid;
		this.isModalOpen = true;
	}

	closeModal() {
		this.isModalOpen = false;
	}

	editQualification(row: Qualification) {
		this.newQualification = row;
		this.isModalOpen = true;
	}
	
	deleteQualification(row: Qualification) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-qualification-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.qualificationCrudService
					.deleteEntity(Qualification, 'qualification', row)
					.then(() => {
						this.loadQualifications();
						this.$buefy.notification.open({
							message: this.$t('success-save') as string,
							type: 'is-success',
						});
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});

	}

	submit() {
		const call = (this.newQualification!.id) ? 
			this.qualificationCrudService.saveEntity(Qualification, 'qualification', this.newQualification) : 
			this.qualificationCrudService.createEntity(Qualification, 'qualification', this.newQualification);
		call.then(result => {
			this.newQualification = result;
			this.closeModal();
			this.loadQualifications();
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
		});
	}
	
}
